import React, {Component} from 'react';
import ComTemperature from '../../components/ComTemperature';

class COM extends Component {

    render() {
        return (
            <div>
                <ComTemperature/>
            </div>
        );
    }
}

export default COM;



// WEBPACK FOOTER //
// ./src/views/COM/COM.js